<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link v-if="this.gstock" :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("integraciones") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-4" >
        <h2><i class="fas fa-warehouse"></i> {{ $t("almacen") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                  v-if="this.gstock"
                :to="{ name: 'gstock' , params: { pag: 1 } }"
              >
                <li>
                  {{ $t('GStock') }}
                  <br />
                  <span class="text-muted">{{ $t('herramientaControlStockControlComprasInventarios') }}</span>
                </li>
              </router-link>
              <router-link
                  v-if="this.gstock"
                :to="{ name: 'productosnorelacionados' , params: { pag: 1 } }"
              >
                <li>{{ $t('productosNoRelacionados') }}<br />
                  <span class="text-muted">{{ $t('productosNoRelacionadosDescripcion') }}</span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>
      <div class="col-md-4" >
        <h2><i class="fas fa-warehouse"></i> {{ $t("fidelizacion") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                  v-if="this.cheerfy"
                :to="{ name: 'cheerfy' }"
              >
                <li>
                  {{ $t('cheerfy') }}
                  <br />
                  <span class="text-muted">{{ $t('plataformaGestionPromocionesClientes') }}</span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import bus from '../../../bus'
  import { mapState } from 'vuex';
  export default {
    created() {
      this.$store.dispatch("setNameRoute","Integraciones");

      bus.$on('get-business', (idBusiness) => {
        this.idBusiness = idBusiness;
        this.idsTPV = [];
        this.idTpv = 0;
      });
      
      this.getTpvsRetail();
      this.tieneGStock();
      this.tieneCheerfy();
    },

    data() {
      return {
        soloRetail:true,
        idBusiness: this.$store.getters.idBusiness,
        ListidBusiness:[],
        ListidTpvs:[],
        gstock:true,
        cheerfy: true,
        idTpv: 0,
      };
    },

    computed: {
      ...mapState(["listaSectores", "sectores"]),
    },

    methods: {
      // getBusiness() {
      //   var config = {
      //     params: {
      //       jwt: this.$store.getters.jwt,
      //     },
      //     headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      //   };
  
      //   let vm = this;
      //   this.axios
      //     .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
      //     .then(function(response) {
      
            
      //       response.data.result.forEach(element => {
      //         vm.ListidBusiness.push(element.id)
      //       });
          
      //       vm.getTpv();
  
      //     })
      //     .catch(function(error) {
      //       console.log(error);
      //     });
      // },
      // getTpv() {
        
      //     var config = {
      //         params: {
      //             idBusiness: this.ListidBusiness,
      //             jwt: this.$store.getters.jwt
      //         },
      //         headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      //     };
    
      //     let vm = this;
      //     this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
      //       .then(function (response) {
    
      //         if (response.data.response) {
                
      //           vm.ListidTpvs=response.data.result;
      //           //console.log(vm.ListidTpvs);
      //           //vm.tieneGStock();
      //         }
      //     })
      //     .catch(function (error) {
      //         console.log(error);
      //     });
      //  // vm.tieneGStock();
      // },
      getTpvsRetail(){
          var config = {
            params: {
                idTpv: this.idTpv,
                jwt: this.$store.getters.jwt
            },
            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
          };
        let vm = this;
        this.axios.get(this.$store.getters.apiUrl + "tpvs/getTpvsRetail", config)
        .then(function (response) {
          if(response.data.result){
            vm.soloRetail = false;
          }else{
            vm.soloRetail = true;
          
          }
        })
      },
      tieneGStock() {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.getters.apiUrl + "general/getRestrictionsByUser",
            config
          )
          .then(function (response) {
            if (response.data.response) {
              for (let i = 0; i < response.data.result.length; i++) {
                
                switch (response.data.result[i].idRestriction) {
                  case "72":
                    vm.gstock = true;
                    break;
                  }
                }
              }
            })
            .catch(function(error) {
              console.log(error);
            });
      },
      tieneCheerfy() {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.getters.apiUrl + "general/getRestrictionsByUser",
            config
          )
          .then(function (response) {
            if (response.data.response) {
              for (let i = 0; i < response.data.result.length; i++) {
                
                switch (response.data.result[i].idRestriction) {
                  case "75":
                    vm.cheerfy = true;
                    break;
                  }
                }
              }
            })
            .catch(function(error) {
              console.log(error);
            });
      },
    },
  };
</script>
<style scoped>
  h3 {
    margin: 10px 0;
    color: #1E22AA;
    font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
  }
  
  h2 {
    margin: 10px 5px;
    font-family: "Numier", "Helvetica Neue", Arial;
    font-weight: bold;
    color: #1E22AA;
    font-size: 25px;
  }
  
  i {
    font-size: 20px;
  }
  
  .list-files {
    padding: 0;
    margin-bottom: 0px;
  }
  
  .list-files a:first-child li {
    border-top: none;
  }
  
  .list-files a li {
    list-style: none;
    padding: 15px 20px;
    font-size: 1.1em;
    border-top: 1px solid #bbb;
    /*font-weight: bold;*/
    color: #252422;
  }
  
  .list-files a li span {
    font-size: 0.7em;
  }
  
  .list-files p {
    margin: 0;
  }
  
  .list-files a li:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.2);
  }
  
  .content-card {
    border-top: 2px solid #00A3AD;
    padding: 0;
  }
  
  .prox {
    font-weight: 400;
    font-size: 0.8em;
  }
</style>
  


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/Integraciones.vue